import { t, Trans } from '@lingui/macro'
import { Download, HighlightOff, KeyboardArrowDown, KeyboardArrowUp, KeyboardTab, LockOutlined, NavigateBeforeOutlined, NavigateNext, Save } from '@mui/icons-material'
import {
  Alert,
  Box, Checkbox,
  Collapse,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  Icon,
  Typography
} from '@mui/material'
import Button from '@mui/material/Button'
import withStyles from '@mui/styles/withStyles'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { dateFormat, portalLanguagesData } from 'app/appSettings'
import { queryCreateObject } from 'app/backend/Common'
import { useGlobalQueries } from 'app/GlobalQueriesProvider'
import sfOauthConfig from 'app/services/sfAuth/sfAuthConfig'
import sfAuthService from 'app/services/sfAuth/SFAuthService'
import {
  createCases
} from 'app/services/sfAuth/sfData/sfCase'
import { getDocumentsByEntity } from 'app/services/sfAuth/sfData/sfFiles'
import { checkIfScoreCardExistForTemplate } from 'app/services/sfAuth/sfData/sfScoreCard'
import {
  addSurveyByFlow,
  changeSurveyLockByFlow,
  findCompletedSurveysParsed,
  getSubtemplates,
  getSurveyParsedByFlow,
  getSurveyTemplateDetails,
  isConfiguredTemplate, SATsIdsList, saveSurveyData,
  surveyConfigurationVariables,
  surveyItemOptionsFields,
  surveyMapping,
  templateIdToMapping
} from 'app/services/sfAuth/sfData/sfSurvey'
import {
  questionToMultilanguageText
} from 'app/utils/survey/surveyToRTF'
import Loading from 'egret/components/EgretLoadable/Loading'
import { Formik } from 'formik'
import { isError, isString } from 'lodash'
import moment from 'moment'
import { closeSnackbar, useSnackbar } from 'notistack'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { connect, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { handleErrorFeedback, isValidSalesforceId } from 'utilsTS'
import * as Yup from 'yup'
import {
  myI18n
} from '../../../translation/I18nConnectedProvider'
import { ButtonIcon } from '../common-components/ButtonIcon'
import { DialogTitleWithIconClose } from '../common-components/DialogTitleWithIconClose'
import RedirectWarning from '../common-components/RedirectWarning'
import { CheckboxWithFormik } from '../common-components/with-formik/CheckboxWithFormik'
import SaveWillOverrideWarningDialog from '../common/SaveWillOverrideWarningDialog'
import { getLabelFromTranslationData } from '../common/translationsCommon'
import '../forms/common/FormErrorsList.scss'
import { FormErrorPopUp } from '../forms/FormErrorPopUp'
import {
  dateRangeRequiredTrans, questionRequiredTrans, questionRequiredTransWithStar
} from '../forms/formTranslations'
import { shouldBlockAutoSaveForUser } from '../forms/formUtils'
import { HEADER } from '../opportunity/opportunityViewComponents'
import { SAT_PATHS } from '../self-assessment/SATConstants'
import { NOT_FOUND_PATH } from '../sessions/SessionRoutes'
import QuestionTitle from './QuestionTitle'
import {
  fixedQuestionAnswers,
  questionTypes, QuestionWidget
} from './QuestionWidget'
import { SURVEY_PATHS } from './SurveyConstants'
import { SurveyContextProvider } from './SurveyContext'
import { renderSurveyQuestionToolitp } from './surveyQustions'
import './SurveyStyles.scss'
import SurveySubmittedPdf from './SurveySubmittedPdf'
import { SurveyTabStepper } from './SurveyTabStepper'
import { questionValidationRules } from './ValidationRulesField'

export const questionToInitial = item => {
  if (item.isGroup && item.groupQuestions) {
    return [item.id.toString(), Array(item.groupQuestions.length).fill('')]
  }
  switch (item.type) {
    case questionTypes.INPUT_TEXT.id:
      return [item.id.toString(), '']
    case questionTypes.INPUT_TEXTAREA.id:
      return [item.id.toString(), '']
    case questionTypes.SELECT_ONE.id:
      return [item.id.toString(), null]
    case questionTypes.SELECT_MULTIPLE.id:
      return [item.id.toString(), Array(item.options.length).fill(false)]
    default:
      return [item.id.toString(), '']
  }
}

export const questionsToInitial = questionList => {
  const ret = {
    submitButtonType: 'Saved'
  }
  for (const i of questionList.map((item, index) => {
    return questionToInitial(item)
  })) {
    ret[i[0]] = i[1]
  }
  return ret
}

export const nonApplicableSuffix = '_nonApplicable'
const answerToInit = survey => {
  try {
    if (survey) {
      const ret = JSON.parse(survey.answer)
      return ret
    }
  } catch (e) {
    console.warn('could not load answer data', e)
  }
  return {}
}

const defaultSurveyError = questionRequiredTrans

const styles = theme => ({
  formik: {
    margin: '0 auto',
    width: '100%',
    maxWidth: 1350,
    textAlign: 'left'
    // width: 800
  },
  question: {
    padding: 12,
    margin: 8,
    textAlign: 'left'
  },
  submitButton: {
    margin: 10
  }
})

export const saveFile = (filename, data, { type = 'text/csv' }) => {
  const blob = new Blob([data], { type })
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, filename)
  } else {
    const elem = window.document.createElement('a')
    elem.href = window.URL.createObjectURL(blob)
    elem.download = filename
    document.body.appendChild(elem)
    elem.click()
    document.body.removeChild(elem)
  }
}

const exportDataFunctions = (toSet, templateId, configuration) => {
  console.log('export toSet', toSet)
  const surveyScoreCard = templateIdToMapping(templateId, configuration)
  const exportData = toSet
    .map(item => {
      return item.questions
        .map(question => {
          if (question.isGroup) {
            return question.groupQuestions.map(subquestion => ({
              id: `${question.id}.${subquestion.index}`,
              text: getLabelFromTranslationData({
                langVersion: 'en',
                data: subquestion.titleValue
              }),
              parentText: getLabelFromTranslationData({
                langVersion: 'en',
                data: question.titleValue
              }),
              templateName: question.templateName,
              date: question.createdDate,
              ...Object.fromEntries(
                question.options.map((item, index) => [
                  `option_${index + 1}`,
                  item.text
                ])
              )
            }))
          }
          return {
            id: question.id,
            text: getLabelFromTranslationData({
              langVersion: 'en',
              data: question.titleValue
            }),
            date: question.createdDate,
            templateName: question.templateName,
            children: question.groupQuestions,
            parentText: '',
            ...Object.fromEntries(
              question.options.map((item, index) => [
                `option_${index + 1}`,
                item.text
              ])
            )
          }
        })
        .flat()
    })
    .flat()
  const fixDoubles = {}
  const filteredDoubles = []

  exportData.forEach(item => {
    if (!fixDoubles[item.id]) {
      filteredDoubles.push(item)
      fixDoubles[item.id] = true
    }
  })

  const csv = filteredDoubles.map(item => {
    let scoringGroup = ''
    let multiple = ''
    let modifier = ''
    if (surveyScoreCard[item.id]) {
      scoringGroup = surveyScoreCard[item.id]['Scoring group']
      multiple = surveyScoreCard[item.id].multiple
      modifier = surveyScoreCard[item.id].modifier
    }

    return (
      `"${item.id}","${item.parentText}", "${item.text}", "${
        item.date && item.date.split('.')[0]
      }", "${item.templateName}", "${scoringGroup}",` +
      `"${modifier}", "${multiple}",` +
      [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
        .map(optionIndex => {
          const scoreCardOption =
            surveyScoreCard[item.id] &&
            surveyScoreCard[item.id][`Option ${optionIndex}`]
          return item[`option_${optionIndex}`]
            ? scoreCardOption && scoreCardOption !== 'undefined'
              ? `"${scoreCardOption}"`
              : `"${item[`option_${optionIndex}`]}"`
            : ''
        })
        .join(',')
    )
  })
  csv.unshift(
    [
      'QuestionID',
      'Parent Text',
      'Text EN',
      'Created date',
      'Section',
      'Scoring group',
      'modifier',
      'multiple',
      'Option 1',
      'Option 2',
      'Option 3',
      'Option 4',
      'Option 5',
      'Option 6',
      'Option 7',
      'Option 8',
      'Option 9',
      'Option 10',
      'Option 11',
      'Option 12'
    ]
      .map(i => `"${i}"`)
      .join(',')
  )

  saveFile('fileCSV.csv', csv.join('\r\n'))

  console.log('export', exportData)
}

const isSubquestion = dataObj => {
  return (
    dataObj.itemOptions.parentQuestionIndex ||
    dataObj.itemOptions.parentQuestionIndex === 0 ||
    dataObj.itemOptions.parentQuestionId
  )
}

export const sfDataToRenderData = (result, templateId, props) => {
  const { user = {} } = props
  const subtemplatesIds = result.templates
    .sort((a, b) => a.order - b.order)
    .map(item => item.id)
  const detailsPromises = []
  detailsPromises.push(getSurveyTemplateDetails(templateId))
  subtemplatesIds.forEach(id => {
    detailsPromises.push(getSurveyTemplateDetails(id))
  })
  return Promise.all(detailsPromises).then(result => {
    const toSet = []
    result.forEach((template, index) => {
      const section = { ...template.templateOptions }
      section.questions = []
      section.templateId = template.info.templateId
      section.header = template.info.surveyName
      if (template.titleDetails) {
        section.header =
          getLabelFromTranslationData({
            langVersion: user.language,
            data: template.titleDetails.titleValue
          }) || template.info.surveyName
        section.tooltip = getLabelFromTranslationData({
          langVersion: user.language,
          data: template.titleDetails.tooltipValue
        })
        section.tooltipValue = template.titleDetails.tooltipValue
        section.headerValue = template.titleDetails.titleValue
      }
      if (template.questionsDetails.length === 0) {
        toSet.push(section)
        return
      }
      template.questionsDetails.sort((a, b) => {
        return a.order - b.order
      })
      const groupQuestions = {}
      template.questionsDetails.forEach((dataObj, index) => {
        if (!dataObj.itemOptions) {
          return
        }
        if (isSubquestion(dataObj)) {
          const toPush = {
            titleValue: dataObj.itemTranslation.titleValue,
            index: dataObj.itemOptions.index,
            id: dataObj.itemOptions.createdId
          }
          const parentId =
            dataObj.itemOptions.parentQuestionId ||
            dataObj.itemOptions.parentQuestionIndex
          if (groupQuestions[parentId]) {
            groupQuestions[parentId].push(toPush)
          } else {
            groupQuestions[parentId] = [toPush]
          }
        }
      })
      template.questionsDetails.forEach(question => {
        let isGroup = false
        const childQuestions = []
        const inTemplates = []
        const otherTemplatesIDs = []
        question.item.Survey_Joins_Template_and_Question__r.records.forEach(
          join => {
            const options = JSON.parse(join.Item_Options__c)
            if (join.Id !== question.joinId) {
              inTemplates.push(join.Survey_Template__c)
              if (options.mainTemplate) {
                inTemplates.push(options.mainTemplate)
              }
              otherTemplatesIDs.push(options.createdId)
            }
          }
        )
        const crypto = require('crypto')
        const assignId = crypto.randomBytes(20).toString('hex')
        if (!question.itemOptions) {
          question.itemOptions = {
            optionsWithRequiredDetails: [],
            conditions: [],
            conditionsToCheck: [],
            externalConditions: [],
            createdId: assignId
          }
        } else if (!question.itemOptions.createdId) {
          question.itemOptions.createdId = assignId
        }
        if (isSubquestion(question)) {
          return
        }
        const questionOptions = []
        if (question.itemOptions.isGroup === true) {
          isGroup = true
          const subQuestions =
            groupQuestions[question.itemOptions.createdId] ||
            groupQuestions[question.order]
          if (subQuestions) {
            subQuestions.sort((a, b) => {
              return a.index - b.index
            })
            subQuestions.forEach(sub => {
              childQuestions.push({
                titleValue: sub.titleValue,
                index: sub.index,
                id: sub.id
              })
            })
          }
        }

        const optionsWithRequiredDetails = {}
        question.itemOptions.optionsWithRequiredDetails.forEach(detailObj => {
          if (!detailObj) {
            return
          }
          const type = detailObj.type ? detailObj.type : 'text'
          const index =
            detailObj.index || detailObj.index === 0
              ? detailObj.index
              : detailObj
          optionsWithRequiredDetails[index] = type
        })
        question.itemDetails.sort((a, b) => a.order - b.order)
        question.itemDetails.forEach(detail => {
          const requireDetails = optionsWithRequiredDetails[detail.order]
          questionOptions.push({
            text: getLabelFromTranslationData({
              langVersion: user.language,
              data: detail.titleValue
            }),
            titleValue: detail.titleValue,
            apiValue: detail.apiValue,
            requireDetails: requireDetails || null,
            clearOnSelect: Boolean(detail.clearOnSelect)
          })
        })
        if (fixedQuestionAnswers[question.item.Type__c]) {
          fixedQuestionAnswers[question.item.Type__c].forEach(option => {
            questionOptions.push({
              text: option,
              requireDetails: null
            })
          })
        }
        const questionObj = {
          templateName: template.info.surveyName,
          type: question.item.Type__c,
          conditionsToCheck: question.itemOptions.conditionsToCheck || [],
          conditions: question.itemOptions.conditions || [],
          externalConditions: question.itemOptions.externalConditions || [],
          validationRules: question.itemOptions.validationRules || [],
          createdDate: question.item.CreatedDate,
          isGroup,
          otherTemplatesIDs,
          inTemplates,
          sfId: question.item.Id,
          groupQuestions: childQuestions,
          options: questionOptions,
          version: user.language,
          id: question.itemOptions.createdId,
          text: getLabelFromTranslationData({
            langVersion: user.language,
            data: question.itemTranslation.titleValue
          }),
          tooltip: getLabelFromTranslationData({
            langVersion: user.language,
            data: question.itemTranslation.tooltipValue
          }),
          tooltipValue: question.itemTranslation.tooltipValue,
          titleValue: question.itemTranslation.titleValue
        }
        surveyItemOptionsFields.forEach(field => {
          questionObj[field] = question.itemOptions[field]
        })
        section.questions.push(questionObj)
      })
      toSet.push(section)
    })
    return toSet
  })
}

export const suveyTempalteDataToQuestions = templates => {
  const ret = {}
  for (const subtemplate of templates) {
    for (const question of subtemplate.questions) {
      ret[question.id] = question
    }
  }
  return ret
}

const surveyScoringAvailable = (templateId, configuration) => {
  const configurationKeys = Object.values(surveyMapping).map(item => ({
    key: item.configuration.key,
    hasScore: item.hasScore
  }))
  for (const { key, hasScore } of configurationKeys) {
    if (configuration[key] === templateId && hasScore) {
      return true
    }
  }
  return false
}

const KNOWN_SURVEY_ERRORS = [
  {
    logic: error => error.includes('INSUFFICIENT_ACCESS_OR_READONLY'),
    id: 'SURVEY_IS_LOCKED'

  }
]

const SurveyTab = ({
  disabled = null,
  viewMode = 'editable',
  opportunity,
  embedded,
  noSubmit = false,
  noSave = false,
  submitCallback,
  saveCallback,
  requiredQuestions = [],
  linkedQuestions = [],
  templatesToCheck = [],
  linkedObjects,
  isExternalReview = false,
  isConfirm = false,
  ...props
}) => {
  const [data, setData] = useState(null)
  const formRef = useRef()
  const [survey, setSurvey] = useState(null)
  const [noPermission, setNoPermission] = useState(false)
  const [entityFiles, setEntityFiles] = useState([])
  const [linkedQuestionsToCheck, setLinkedQuestionsToCheck] =
    useState(linkedQuestions)
  const [initialValues, setInitialValues] = useState({})
  const [requiredIDs, setRequiredIDs] = useState(requiredQuestions)
  const [completedSurveys, setCompletedSurveys] = useState([])
  const [scoreCardExists, setScoreCardExists] = useState(false)
  const [savingError, setSavingError] = useState(null)
  const { enqueueSnackbar } = useSnackbar()
  const configuration = useSelector(state => state.configuration)
  const organization = useSelector(state => state.organization)
  const history = useHistory()
  const userLanguage = useSelector(state => state.user.language)
  const user = useSelector(state => state.user)
  let isSAT = false
  const templateId = props.templateId
    ? props.templateId
    : props.match
      ? props.match.params.id
      : null
  const surveyId = props.surveyId
    ? props.surveyId
    : props.match
      ? props.match.params.surveyId
      : null

  isSAT = isConfiguredTemplate(templateId, configuration, [
    surveyConfigurationVariables.E_SAT_SURVEY.key,
    surveyConfigurationVariables.SAT_COOPS_SURVEY.key,
    surveyConfigurationVariables.SAT_OSBL_SURVEY.key
  ])

  console.log('surveyTab params', {
    disabled,
    survey,
    data,
    noSubmit,
    match: props.match,
    linkedQuestionsToCheck,
    opportunity
  })

  const classes = props.classes
  const questionMap = data ? suveyTempalteDataToQuestions(data) : {}

  useEffect(() => {
    if (data === null && !props.renderData) {
      fetchData()
    } else if (props.renderData && data === null) {
      setData(props.renderData)
      let title = ''
      props.renderData.some(template => {
        if (template.templateId === templateId) {
          title = template.header
          return true
        }
      })
      if (surveyId) {
        getSurveyParsedByFlow(surveyId).then(survey => {
          setSurvey({ ...survey, title })
        })
      } else {
        setSurvey({
          ...survey,
          title
        })
      }
    }
  }, [])

  const fetchData = () => {
    setData(null)
    if (
      !isValidSalesforceId(templateId) &&
      !isValidSalesforceId(surveyId)
    ) {
      history.push(NOT_FOUND_PATH)
      return
    }
    Promise.all([
      getSurveyParsedByFlow(surveyId),
      getSubtemplates(templateId).then(result => {
        return sfDataToRenderData(result, templateId, {
          configuration,
          ...props
        })
      }),
      findCompletedSurveysParsed(
        templateId
      ),
      getDocumentsByEntity(opportunity && opportunity.reportId),
      checkIfScoreCardExistForTemplate(templateId)
    ])
      .then(
        ([
          survey,
          templates,
          completedSurveys,
          files,
          scoreCardExists
        ]) => {
          console.log(
            'gote surveys and template',
            survey,
            templates,
            completedSurveys,
            user
          )
          console.log(
            'got files',
            opportunity && opportunity.reportId,
            files
          )
          if (!survey) {
            setNoPermission(true)
            return
          }
          if (
            survey.locked &&
            survey.owner !== user.userId &&
            survey.surveyState !== 'Submitted'
          ) {
            // if (viewMode !== 'view') {
            //   history.goBack()
            //   enqueueSnackbar(
            //     <Trans>This survey is locked by another user!</Trans>,
            //     { variant: 'error' }
            //   )
            // }
          }
          const valuesParsed = JSON.parse(survey.answer) || {}
          const toSetInitial = {
            skippedSections: { ...valuesParsed?.skippedSections }
          }
          Object.keys(valuesParsed).forEach(key => {
            if (key.indexOf(nonApplicableSuffix) !== -1 && valuesParsed[key]) {
              toSetInitial[key] = valuesParsed[key]
            }
          })
          setInitialValues(toSetInitial)
          setEntityFiles(
            files.map((item, index) => ({
              name: item.ContentDocument.Title,
              description: item.ContentDocument.Description,
              uploadId: index,
              tags: item.ContentVersion.TagCsv,
              id: item.ContentDocumentId
            }))
          )
          const extraTemplates = templatesToCheck || []
          const requiredQuestions = []
          const linkedQuestions = []
          templates.forEach(template => {
            if (template.templateId === templateId) {
              survey.title = template.header
              if (SATsIdsList.includes(template.templateId)) {
                survey.title = survey.name
                survey.noDateInTitle = true
              }
              survey.autosave = template.autosave
              survey.translatedFor = template.translatedFor
            }
            template.questions.forEach(question => {
              if (question.inTemplates.length > 1) {
                question.inTemplates.forEach(id => {
                  if (!extraTemplates.includes(id) && id !== templateId) {
                    extraTemplates.push(id)
                  }
                })
              }
              if (question.linkedField && question.linkedObject) {
                linkedQuestions.push({
                  linkedField: question.linkedField,
                  linkedObject: question.linkedObject,
                  id: question.id,
                  sfID: question.sfID
                })
              }
              if (
                question.isRequired &&
                question.type !== questionTypes.HEADER.id
              ) {
                requiredQuestions.push({
                  id: question.id,
                  type: question.type,
                  isGroup: question.isGroup
                })
              }
            })
          })
          if (extraTemplates.length > 0) {
            findCompletedSurveysParsed([...extraTemplates]).then(result => {
              const toCheck = [...completedSurveys, ...result]
              toCheck.sort(
                (a, b) => new Date(b.modifiedDate) - new Date(a.modifiedDate)
              )
              setCompletedSurveys([...toCheck.map(item => answerToInit(item))])
            })
          } else {
            setCompletedSurveys([
              ...completedSurveys.map(item => answerToInit(item))
            ])
          }
          setScoreCardExists(scoreCardExists)
          setData(templates)
          setRequiredIDs(requiredQuestions)
          setLinkedQuestionsToCheck(linkedQuestions)
          setSurvey(survey)
        }
      )
      .catch(error => {
        console.error('getting templates', error, surveyId, templateId)
        handleErrorFeedback({
          enqueueSnackbar,
          message: <Trans>SURVEY_TAB_LOADING_ERROR_SNACKBAR</Trans>,
          error
        })
      })
  }

  useEffect(() => {
    if (data) {
      const newData = [...data]
      newData.forEach(obj => {
        obj.header = obj.headerValue[user.language]
        obj.tooltip = obj.tooltipValue[user.language]
        obj.questions.forEach(question => {
          question.text = getLabelFromTranslationData({
            langVersion: user.language,
            data: question.titleValue
          })
          question.tooltip = getLabelFromTranslationData({
            langVersion: user.language,
            data: question.tooltipValue
          })
          if (question.options) {
            question.options.forEach(option => {
              const isTrans = option.text && option.text.id
              if (!isTrans) {
                option.text = getLabelFromTranslationData({
                  langVersion: user.language,
                  data: option.titleValue
                })
              }
            })
          }
        })
      })
      setData(newData)
    }
  }, [userLanguage])

  const handleSavingError = ({ savingKey, error }) => {
    closeSnackbar(savingKey)
    enqueueSnackbar(<Trans>Error Saving Survey</Trans>, {
      variant: 'error'
    })
    queryCreateObject({
      type: 'Error Log',
      createData: {
        severity: 'error',
        description: sfOauthConfig.oauth2.redirectUri + history.location.pathname,
        longDescription: JSON.stringify(error)
        // longDescription: stringifiedLog.length < 131072 ? stringifiedLog : 'Error log was too long'
      }
    })
    const errorString = isError(error) ? error.name : error
    const knownError = isString(errorString) ? KNOWN_SURVEY_ERRORS.find(obj => obj.logic(errorString)) : null
    setSavingError({
      message: knownError ? knownError.id : JSON.stringify(error)
    })
  }

  const submitSurvey = useCallback(
    (values, { setSubmitting, resetForm, unlock }) => {
      console.log('submitSurvey', values)
      const savingKey = enqueueSnackbar(<Trans>Saving Survey</Trans>, {
        variant: 'info'
      })
      const submitButtonType = values.submitButtonType || 'Saved'
      const disableIds = values.disableFields
      delete values.disableFields
      delete values.submitButtonType
      setSubmitting(true)
      const casesToCreate = []
      if (submitButtonType === 'Submitted') {
        Object.values(questionMap).forEach(question => {
          if (question.createCase && question.caseType && values[question.id]) {
            casesToCreate.push({
              Type: question.caseType,
              AccountId: organization.id,
              Description: values[question.id],
              Language__c: userLanguage,
              SuppliedName: user.displayName,
              ContactId: user.userObject.contactId,
              Subject: survey.title
            })
          }
        })
      }
      if (survey) {
        Promise.all([
          saveSurveyData({
            name: survey.title,
            id: survey.id,
            opportunityId: opportunity?.id,
            accountId: organization?.id,
            userId: user.userId,
            values,
            submitButtonType,
            template: data,
            disableIds
          }),
          casesToCreate.length > 0
            ? createCases(casesToCreate)
            : Promise.resolve([]),
          unlock &&
            changeSurveyLockByFlow({
              surveyId: survey.id,
              lockState: false,
              userId: user.userId
            })
        ])
          .then(
            ([saveResult, casesResult, unlockResult]) => {
              console.log('cases from survey', casesResult)
              console.log('saveSurveyData', saveResult)
              if (unlock && unlockResult.result !== 'RESULT_UNLOCKED') {
                enqueueSnackbar(
                  <Trans>
                    Error ocurred while trying to unlock this survey
                  </Trans>,
                  {
                    variant: 'error'
                  }
                )
              }
              if (casesResult.some(res => !res.success)) {
                enqueueSnackbar(
                  <Trans>
                    There was a problem with submitting some of your comments
                  </Trans>,
                  {
                    variant: 'error'
                  }
                )
              }
              if (!saveCallback) {
                closeSnackbar(savingKey)
                resetForm({ values })
                enqueueSnackbar(<Trans>Saved Survey</Trans>, {
                  variant: 'success'
                })
                if (unlock) {
                  history.push(SAT_PATHS.MY_ASSESSMENTS)
                }
                getSurveyParsedByFlow(surveyId).then(survey => {
                  setSurvey(survey)
                  setSubmitting(false)
                })
              }
              if (
                submitButtonType === 'Submitted' ||
                submitButtonType === 'Applied'
              ) {
                if (submitCallback) {
                  submitCallback(values, {
                    linkedQuestionsToCheck,
                    disableFields: disableIds,
                    templateData: data,
                    surveyId: saveResult.id
                  })
                  resetForm({ values })
                  getSurveyParsedByFlow(surveyId).then(survey => {
                    setSurvey(survey)
                  })
                } else {
                  if (surveyScoringAvailable(templateId, configuration)) {
                    history.push(`${SURVEY_PATHS.SURVEY_SCORE}/${surveyId}/${templateId}`)
                  } else {
                    // TODO handle coming to the survey better
                    history.goBack()
                  }
                }
              } else if (submitButtonType === 'Saved' && saveCallback) {
                saveCallback(values, {
                  linkedQuestionsToCheck,
                  disableFields: disableIds,
                  surveyId: saveResult.id,
                  templateData: data
                }).then(
                  result => {
                    resetForm({ values })
                    closeSnackbar(savingKey)
                    enqueueSnackbar(<Trans>Saved Survey</Trans>, {
                      variant: 'success'
                    })
                    if (unlock) {
                      history.push(SAT_PATHS.MY_ASSESSMENTS)
                    }
                    getSurveyParsedByFlow(surveyId).then(survey => {
                      setSurvey(survey)
                      setSubmitting(false)
                    })
                  },
                  reject => {
                    console.error('error saving survey', reject)
                    closeSnackbar(savingKey)
                    enqueueSnackbar(<Trans>Error Saving Survey</Trans>, {
                      variant: 'error'
                    })
                  }
                )
              } else {
                getSurveyParsedByFlow(surveyId).then(survey => {
                  setSurvey(survey)
                  setSubmitting(false)
                })
              }
            },
            reject => {
              console.log('error', reject)
              handleSavingError({ savingKey, error: reject })
              getSurveyParsedByFlow(surveyId).then(survey => {
                setSurvey(survey)
                setSubmitting(false)
              })
            }
          )
          .catch(error => {
            console.error('error saving survey', error)
            handleSavingError({ savingKey, error })
            getSurveyParsedByFlow(surveyId).then(survey => {
              setSurvey(survey)
              setSubmitting(false)
            })
          })
      } else {
        // TODO this does not submit after creation check where it can be used
        Promise.all([
          addSurveyByFlow(
            {
              surveyTemplate: props.createSurveyType,
              accountId: props.organization.id,
              opportunityId: opportunity?.id,
              userId: user.userId
            },
            configuration
          ),
          casesToCreate.length > 0
            ? createCases(casesToCreate)
            : Promise.resolve([])
        ]).then(
          ([result]) => {
            resetForm({ values })
            closeSnackbar(savingKey)
            enqueueSnackbar(<Trans>Saved Survey</Trans>, {
              variant: 'success'
            })
            if (submitButtonType === 'Submitted') {
              history.push(`${SURVEY_PATHS.SURVEY_SCORE}/${surveyId}/${templateId}`)
            }
            setSubmitting(false)
          },
          reject => {
            console.error('error saving survey', reject)
            handleSavingError({ savingKey, error: reject })
            setSubmitting(false)
            resetForm({ values })
          }
        )
      }
    },
    [survey, data, opportunity, user, organization]
  )

  const [validationSchema, setValidationSchema] = useState()

  useEffect(() => {
    const yupObj = {}
    const requiredIDsValues = requiredIDs.map(i => i.id)
    requiredIDs.forEach(obj => {
      if (obj.type === questionTypes.SELECT_MULTIPLE.id) {
        yupObj[obj.id] = Yup.array()
          .nullable()
          .compact()
          .min(1, questionRequiredTransWithStar)
          .required(questionRequiredTransWithStar)
      } else if (obj.type === questionTypes.INPUT_DATE_RANGE.id) {
        if (obj.isGroup) {
          yupObj[obj.id] = Yup.array().of(
            Yup.mixed()
              .required(dateRangeRequiredTrans)
              .dateRangeRequired(dateRangeRequiredTrans)
          )
        } else {
          yupObj[obj.id] = Yup.mixed()
            .required(dateRangeRequiredTrans)
            .dateRangeRequired(dateRangeRequiredTrans)
        }
      } else if (
        obj.type === questionTypes.INPUT_TEXT.id ||
        obj.type === questionTypes.INPUT_TEXTAREA.id
      ) {
        if (obj.isGroup) {
          yupObj[obj.id] = Yup.array()
            .nullable()
            .of(Yup.string().required(questionRequiredTransWithStar))
        } else {
          yupObj[obj.id] = Yup.string().required(questionRequiredTransWithStar)
        }
      } else if (
        obj.type === questionTypes.INPUT_NUMBER.id ||
        obj.type === questionTypes.SLIDER.id
      ) {
        if (obj.isGroup) {
          yupObj[obj.id] = Yup.array()
            .nullable()
            .of(
              Yup.number()
                .transform(v => v || null)
                .nullable()
                .required(questionRequiredTransWithStar)
            )
        } else {
          yupObj[obj.id] = Yup.number()
            .transform(v => v || null)
            .nullable()
            .required(questionRequiredTransWithStar)
        }
      } else if (obj.type === questionTypes.INPUT_DATE.id) {
        if (obj.isGroup) {
          yupObj[obj.id] = Yup.array()
            .nullable()
            .of(Yup.mixed().required(questionRequiredTransWithStar))
        } else {
          yupObj[obj.id] = Yup.mixed().required(questionRequiredTransWithStar)
        }
      } else {
        if (obj.isGroup) {
          yupObj[obj.id] = Yup.array()
            .nullable()
            .of(Yup.string().required(questionRequiredTransWithStar))
        } else {
          yupObj[obj.id] = Yup.mixed().required(questionRequiredTransWithStar)
        }
      }
    })
    if (data) {
      data.forEach(template => {
        template.questions.forEach(question => {
          const questionParams = {
            required: requiredIDsValues.includes(question.id)
          }
          if (question.validationRules) {
            question.validationRules.forEach(rule => {
              if (!rule.type || !rule.parameter) {
                return
              }
              if (yupObj[question.id]) {
                if (question.isGroup) {
                  if (questionValidationRules[rule.type].applyToAll) {
                    yupObj[question.id] = yupObj[question.id].concat(
                      questionValidationRules[rule.type].rule(
                        rule.parameter,
                        questionParams
                      )
                    )
                  } else {
                    yupObj[question.id] = yupObj[question.id].concat(
                      Yup.array()
                        .transform(v => (!v ? [] : v))
                        .nullable()
                        .of(
                          questionValidationRules[rule.type].rule(
                            rule.parameter,
                            questionParams
                          )
                        )
                    )
                  }
                } else {
                  yupObj[question.id] = yupObj[question.id].concat(
                    questionValidationRules[rule.type].rule(
                      rule.parameter,
                      questionParams
                    )
                  )
                }
              } else {
                if (question.isGroup) {
                  if (questionValidationRules[rule.type].applyToAll) {
                    yupObj[question.id] = questionValidationRules[
                      rule.type
                    ].rule(rule.parameter, questionParams)
                  } else {
                    yupObj[question.id] = Yup.array()
                      .transform(v => (!v ? [] : v))
                      .nullable()
                      .of(
                        questionValidationRules[rule.type].rule(
                          rule.parameter,
                          questionParams
                        )
                      )
                  }
                } else {
                  yupObj[question.id] = questionValidationRules[rule.type].rule(
                    rule.parameter,
                    questionParams
                  )
                }
              }
            })
          }
          if (
            question.maxCharacters &&
            [
              questionTypes.INPUT_TEXT.id,
              questionTypes.INPUT_TEXTAREA.id
            ].includes(question.type)
          ) {
            const rule = Yup.string()
              .ensure()
              .max(question.maxCharacters, ({ max }) =>
                myI18n._(t`This fields length cannot exceed ${max} characters!`)
              )
            if (question.isGroup) {
              if (yupObj[question.id]) {
                yupObj[question.id] = yupObj[question.id].concat(
                  Yup.array()
                    .transform(v => (!v ? [] : v))
                    .nullable()
                    .of(rule)
                )
              } else {
                yupObj[question.id] = Yup.array()
                  .transform(v => (!v ? [] : v))
                  .nullable()
                  .of(rule)
              }
            } else {
              if (yupObj[question.id]) {
                yupObj[question.id] = yupObj[question.id].concat(rule)
              } else {
                yupObj[question.id] = rule
              }
            }
          }
          if (question.type === questionTypes.INPUT_NUMBER.id) {
            if (question.min) {
              const rule = Yup.number().min(question.min, ({ min }) =>
                myI18n._(t`Provided value cannot be lesser than ${min}!`)
              )
              if (question.isGroup) {
                if (yupObj[question.id]) {
                  yupObj[question.id] = yupObj[question.id].concat(
                    Yup.array()
                      .transform(v => (!v ? [] : v))
                      .nullable()
                      .of(rule)
                  )
                } else {
                  yupObj[question.id] = Yup.array()
                    .transform(v => (!v ? [] : v))
                    .nullable()
                    .of(rule)
                }
              } else {
                if (yupObj[question.id]) {
                  yupObj[question.id] = yupObj[question.id].concat(rule)
                } else {
                  yupObj[question.id] = rule
                }
              }
            }
            if (question.max) {
              const rule = Yup.number().max(question.max, ({ max }) =>
                myI18n._(t`Provided value cannot be greater than ${max}!`)
              )
              if (question.isGroup) {
                if (yupObj[question.id]) {
                  yupObj[question.id] = yupObj[question.id].concat(
                    Yup.array()
                      .transform(v => (!v ? [] : v))
                      .nullable()
                      .of(rule)
                  )
                } else {
                  yupObj[question.id] = Yup.array()
                    .transform(v => (!v ? [] : v))
                    .nullable()
                    .of(rule)
                }
              } else {
                if (yupObj[question.id]) {
                  yupObj[question.id] = yupObj[question.id].concat(rule)
                } else {
                  yupObj[question.id] = rule
                }
              }
            }
          }
        })
      })
    }
    setValidationSchema(Yup.object().shape(yupObj))
  }, [requiredIDs])

  if (!data || !survey || !surveyId || !templateId) {
    return (
      <>
        <Loading atCenter />
        {noPermission && (
          <Dialog fullWidth maxWidth='sm' open={noPermission}>
            <DialogTitle>
              <Trans>Insufficient access!</Trans>
            </DialogTitle>
            <DialogContent>
              <Trans>
                You don't have sufficient access to view this survey!
              </Trans>
              <div
                style={{
                  padding: 15,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <Button
                  color='primary'
                  variant='contained'
                  onClick={e => {
                    history.push(SAT_PATHS.MY_ASSESSMENTS)
                  }}
                >
                  <Trans>Go back to surveys list</Trans>
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        )}
      </>
    )
  }

  const answers = answerToInit(survey) || {}
  if (linkedObjects && data) {
    console.log('loaded answers', linkedObjects, answers, questionMap, survey)
    for (const linkedQuestion of linkedQuestionsToCheck) {
      if (linkedObjects[linkedQuestion.linkedObject]) {
        const answer =
          linkedObjects[linkedQuestion.linkedObject][linkedQuestion.linkedField]
        const question = questionMap[linkedQuestion.id]
        if (question.type === questionTypes.SELECT_MULTIPLE.id) {
          const answerOptions = []
          const savedOptions = answer ? answer.split(';') : []
          for (const option of question.options) {
            const title = getLabelFromTranslationData({
              langVersion: 'en',
              data: option.titleValue
            })
            if (
              (option.apiValue &&
                savedOptions.indexOf(option.apiValue) !== -1) ||
              savedOptions.indexOf(title) !== -1
            ) {
              answerOptions.push(true)
            } else {
              answerOptions.push(false)
            }
          }
          answers[question.id] = answerOptions
        } else if (question.type === questionTypes.SELECT_ONE.id) {
          let i = 0
          for (const option of question.options) {
            const title = getLabelFromTranslationData({
              langVersion: 'en',
              data: option.titleValue
            })
            if (
              (option.apiValue && option.apiValue === answer) ||
              title === answer
            ) {
              answers[question.id] = `option_${i}`
              break
            }
            i++
          }
        } else {
          answers[question.id] = answer
        }
      }
    }
  }

  const state = survey.surveyState
  const disableStates = ['Submitted', 'Approved', 'Obsolete', 'Scheduled']

  const toInit = []
  const initialTouched = {}
  data.forEach(template => {
    template.questions.forEach(q => {
      toInit.push(q)
      if (q.isGroup) {
        initialTouched[q.id] = q.groupQuestions.map(sub => true)
      } else {
        initialTouched[q.id] = true
      }
    })
  })

  const isLocked = Boolean(survey.locked && survey.owner !== user.userId)

  return (
    <ErrorBoundary
      onError={error => {
        queryCreateObject({
          type: 'Error Log',
          createData: {
            severity: 'error',
            description: sfOauthConfig.oauth2.redirectUri + history.location.pathname,
            longDescription: JSON.stringify({
              cause: error?.cause,
              name: error?.name,
              message: error?.message,
              stack: error?.stack
            })
          }
        })
      }}
      fallbackRender={({ error, resetErrorBoundary }) => {
        return (
          <FormErrorPopUp
            open
            parent='Survey'
            error={{
              message: JSON.stringify({
                cause: error?.cause,
                name: error?.name,
                message: error?.message,
                stack: error?.stack
              })
            }}
            connectedMap={{
              survey: {
                objectType: 'Survey__c',
                sfObject: {
                  Id: survey.id
                }
              }
            }}
            mainConnectedObject='Survey__c'
            type='Unexpected error'
          />
        )
      }}
    >
      {isLocked && !disableStates.includes(state) && (
        <Alert severity='warning'>
          <Trans>
            This survey is currently locked by another user. You can access it
            read only form
          </Trans>
        </Alert>
      )}
      {!survey.translatedFor?.[userLanguage]?.value && (
        <Alert severity='info'>
          <Trans>NOT_SUPPORTED_SURVEY_LANGUAGE</Trans>
        </Alert>
      )}
      <Box sx={{ paddingTop: '20px', paddingLeft: '40px', paddingRight: '40px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <FormErrorPopUp
          open={Boolean(savingError)}
          parent='Survey'
          error={savingError}
          connectedMap={{
            survey: {
              objectType: 'Survey__c',
              sfObject: {
                Id: survey.id
              }
            }
          }}
          mainConnectedObject='Survey__c'
          type='Unexpected error'
        />
        <Formik
          innerRef={formRef}
          enableReinitialize
          initialValues={{
            ...questionsToInitial(toInit),
            ...answers,
            ...initialValues
          }}
          initialTouched={initialTouched}
          validationSchema={validationSchema}
          onSubmit={submitSurvey}
        >
          {formikState => (
            <DisplayedSurvey
              {...props}
              isSAT={isSAT}
              scoreCardExists={scoreCardExists}
              user={user}
              formRef={formRef}
              entityFiles={entityFiles}
              data={data}
              isLocked={isLocked}
              isDisabled={disabled || disableStates.includes(state) || isLocked}
              completedSurveys={completedSurveys}
              classes={classes}
              noSubmit={noSubmit}
              embedded={embedded}
              noSave={noSave}
              history={history}
              opportunity={opportunity}
              validationSchema={validationSchema}
              survey={survey}
              formikState={formikState}
              submitSurvey={submitSurvey}
              isConfirm={isConfirm}
              questionMap={questionMap}
              savingError={savingError}
            />
          )}
        </Formik>
      </Box>
    </ErrorBoundary>

  )
}

export const checkSurveyQuestionsToDisable = ({
  data,
  values,
  opportunity = null
}) => {
  const disableFields = []
  data.forEach(template => {
    template.questions.forEach(question => {
      if (
        question.conditionForObjectField &&
        question.conditionalObject &&
        question.conditionalObjectField &&
        question.conditionalObjectName &&
        opportunity
      ) {
        let disable = checkConditionalsBasedOnObject({
          question,
          opportunity
        })
        if (question.conditionForObjectField === 'enable') {
          disable = !disable
        }
        if (disable) {
          disableFields.push(question.id)
        }
      }
      if (question.externalConditions) {
        if (question.externalConditions.length > 0) {
          question.externalConditions.forEach(external => {
            checkExternalConditions({
              values,
              question,
              disableFields,
              external
            })
          })
        }
      }
      if (question.conditionsToCheck) {
        question.conditionsToCheck.forEach(condition => {
          checkConditions({
            condition,
            values,
            disableFields,
            template
          })
        })
      }
    })
  })
  // disable questions from disabled templates
  for (const templateObject of data) {
    if (disableFields.includes(templateObject.templateId)) {
      for (const q of templateObject.questions) {
        disableFields.push(q.id)
      }
    }
  }
  return disableFields
}

const DisplayedSurvey = props => {
  const {
    formikState,
    scrollbarContentRef,
    printTitle,
    scoreCardExists,
    formRef,
    entityFiles,
    data,
    user,
    isDisabled,
    completedSurveys,
    classes,
    isSAT,
    noSubmit,
    history,
    opportunity,
    validationSchema,
    survey,
    submitSurvey,
    questionMap,
    savingError
  } = props

  const [currentTemplate, setCurrentTemplate] = React.useState(null)
  const [currentStep, setCurrentStep] = React.useState(0)
  const [overrideWarningData, setOverrideWarningData] = React.useState(null)
  const [showInfo, setShowInfo] = useState(false)
  const stickyComponentRef = useRef()
  const [isSticky, setIsSticky] = useState(false)
  const [unlocking, setUnlocking] = useState(false)
  const questionsContainerRef = useRef(null)
  const visibleQuestionsRef = useRef(new Map())
  const blockAutoSave = shouldBlockAutoSaveForUser(user)
  const [pendingScroll, setPendingScroll] = useState(null)
  const [stickyHeaderText, setStickyHeaderText] = useState(null)
  const { enqueueSnackbar } = useSnackbar()
  const stepperRef = useRef()
  const printRef = useRef()
  const {
    values,
    errors,
    isValidating,
    setFieldValue,
    initialValues,
    setValues,
    validateForm,
    setErrors,
    isSubmitting,
    setSubmitting,
    resetForm,
    dirty
  } = formikState
  const missingQuestion = {}
  const sectionToErrors = {}
  const errorsInSections = {}
  let currentIndex = 0
  const organization = useSelector(state => state.organization)
  const printSurvey = Boolean(survey.surveyState === 'Submitted')
  const sectionSkipped =
    currentTemplate &&
    values.skippedSections &&
    values.skippedSections[currentTemplate.templateId]
  const disableFields = useMemo(
    () => checkSurveyQuestionsToDisable({ data, values, opportunity }),
    [values, opportunity]
  )
  const { fundingStreams } = useGlobalQueries()

  if (survey.account && survey.account !== organization.id && isSAT) {
    enqueueSnackbar(
      <Trans>SURVEY_TAB_ANOTHER_ORGANIZATION_ERROR_MESSAGE</Trans>,
      {
        variant: 'warning'
      }
    )
    history.push(SAT_PATHS.MY_ASSESSMENTS)
  }

  const activeSections = data.filter((template, index) => {
    const notAllDisabled = template.questions.some(question => {
      return (
        !disableFields.includes(question.id) &&
        question.type !== HEADER
      )
    })
    if (
      template.questions.length === 0 ||
      disableFields.includes(template.templateId) ||
      !notAllDisabled
    ) {
      return false
    }
    return true
  })

  const noEdit = survey.surveyState === 'Submitted' || (survey.locked && survey.owner !== user.userId)

  if (Object.keys(errors).length !== 0) {
    for (const error in errors) {
      const errorId = error.split('[')[0]
      data.forEach((temp, tempIndex) => {
        let displayIndex = 1
        let qData
        temp.questions.forEach((q, qIndex) => {
          if (q.id === errorId) {
            qData = {
              ...q,
              templateIndex: tempIndex,
              questionIndex: displayIndex,
              templateName: temp.header
            }
          }
          if (!disableFields.includes(q.id) && q.type !== HEADER) {
            displayIndex++
          }
        })
        if (
          qData &&
          !isSectionDisabled(temp) &&
          !disableFields.includes(qData.id) &&
          values.skippedSections &&
          !values.skippedSections[temp.templateId] &&
          !values[qData.id + nonApplicableSuffix]
        ) {
          const errorObj = {
            error: errors[errorId],
            value: values[errorId],
            template: temp.header,
            parent: temp.templateId,
            question: qData,
            aData: qData ? qData.text : null
          }
          missingQuestion[errorId] = errorObj
          sectionToErrors[temp.templateId] = temp.header
          if (!errorsInSections[temp.templateId]) {
            errorsInSections[temp.templateId] = []
          }
          errorsInSections[temp.templateId].push(errorObj)
        }
      })
    }
    console.log('errors values', missingQuestion)
    console.log('errors questions', data)
  } else {
    console.log('errors no valid errors', errors, isValidating)
  }

  const errorsPresent = Object.keys(missingQuestion).length !== 0

  const saveSurvey = (props = {}) => {
    const { unlock } = props
    const ref = formRef.current
    const newValues = { ...ref.values }
    newValues.submitButtonType = 'Saved'
    newValues.disableFields = disableFields
    setValues(newValues)
    submitSurvey(newValues, {
      setSubmitting,
      unlock,
      resetForm
    })
  }

  const unlockSurvey = () => {
    setUnlocking(true)
    return changeSurveyLockByFlow({
      surveyId: survey.id,
      lockState: false,
      userId: user.userId
    }).then(result => {
      if (result.result !== 'RESULT_UNLOCKED') {
        setUnlocking(false)
        enqueueSnackbar(
          <Trans>
            Error ocurred while trying to unlock this survey
          </Trans>,
          {
            variant: 'error'
          }
        )
      } else {
        history.push(SAT_PATHS.MY_ASSESSMENTS)
      }
    })
  }

  const checkSurveySave = (props = {}) => {
    const { unlock } = props
    const ref = formRef.current
    if (!ref.dirty || !sfAuthService.user || Boolean(overrideWarningData)) {
      return
    }
    console.log('survey to save', survey)
    setSubmitting(true)
    const currentValues = { ...ref.values }

    getSurveyParsedByFlow(survey.id).then(alreadySaved => {
      const wasSavedInMeantime = moment(alreadySaved.modifiedDate).isAfter(
        moment(survey.modifiedDate)
      )
      if (wasSavedInMeantime) {
        const savedAnswer = JSON.parse(alreadySaved.answer) || {}
        const dataToPass = {
          type: 'survey'
        }
        Object.keys(savedAnswer).forEach(key => {
          const question = questionMap[key]
          if (question) {
            dataToPass[key] = {
              titleValue: question.titleValue
            }
            if (question.isGroup) {
              for (const groupQuestion of question.groupQuestions) {
                const saved = savedAnswer[key][groupQuestion.index]
                const current = currentValues[key][groupQuestion.index]
                let savedOther
                if (savedAnswer[key + '_other']) {
                  savedOther = savedAnswer[key + '_other'][groupQuestion.index]
                }
                let currentOther
                if (currentValues[key + '_other']) {
                  currentOther =
                    currentValues[key + '_other'][groupQuestion.index]
                }
                savedAnswer[key + '.' + groupQuestion.index] = {
                  ...questionToMultilanguageText(question, saved, savedOther),
                  value: saved,
                  other: savedOther
                }
                currentValues[key + '.' + groupQuestion.index] = {
                  ...questionToMultilanguageText(
                    questionMap[key],
                    current,
                    currentOther
                  ),
                  value: current,
                  other: currentOther
                }
                dataToPass[key + '.' + groupQuestion.index] = {
                  ...Object.values(portalLanguagesData).reduce((obj, lang) => {
                    const langKey = lang.editKey
                    const questionTitle = getLabelFromTranslationData({
                      langVersion: langKey,
                      data: question.titleValue
                    })
                    const groupQuestionTitle = getLabelFromTranslationData({
                      langVersion: langKey,
                      data: groupQuestion.titleValue
                    })
                    obj[langKey] =
                      '[' + questionTitle + '] ' + groupQuestionTitle
                    return obj
                  }, {})
                }
              }
            } else {
              savedAnswer[key] = {
                ...questionToMultilanguageText(
                  questionMap[key],
                  savedAnswer[key],
                  savedAnswer[key + '_other']
                ),
                value: savedAnswer[key],
                other: savedAnswer[key + '_other']
              }
              currentValues[key] = {
                ...questionToMultilanguageText(
                  questionMap[key],
                  currentValues[key],
                  currentValues[key + '_other']
                ),
                value: currentValues[key],
                other: currentValues[key + '_other']
              }
            }
          } else {
            delete savedAnswer[key]
          }
        })
        setOverrideWarningData({
          current: currentValues,
          saved: savedAnswer,
          formData: dataToPass
        })
      } else {
        saveSurvey({ unlock })
      }
    })
  }

  const saveDisabled =
    isSubmitting || !dirty

  const navigateToError = ({ templateIndex, id }) => {
    const sectionIndex = templateIndex

    if (sectionIndex === -1) return

    setCurrentStep(sectionIndex)

    setPendingScroll({ id })
  }

  const handleGoToFirstError = () => {
    const firstQuestion = Object.entries(missingQuestion)[0]
    const isGroupQuestion = Array.isArray(firstQuestion[1].error)
    const groupQuestionIndex = isGroupQuestion
      ? firstQuestion[1].error.findIndex(err => err !== undefined)
      : undefined
    const firstQuestionId = isGroupQuestion && groupQuestionIndex > 0
      ? firstQuestion[1].question.groupQuestions[groupQuestionIndex].id
      : firstQuestion[0]
    const firstQuestionSectionIndex = firstQuestion[1].question.templateIndex - 1

    setCurrentStep(firstQuestionSectionIndex)

    setPendingScroll({ id: firstQuestionId })
  }

  useEffect(() => {
    validateForm().then(res => {
      setErrors(res)
    })
  }, [validationSchema, initialValues])

  // Clear sticky header text when topbar changes
  useEffect(() => {
    setStickyHeaderText(null)
  }, [isSticky])

  // While scrolling up, intersection observer does not handle correctly "not seeing" question at the top so we just clear header text based on scroll postion
  useEffect(() => {
    const scrollElement = scrollbarContentRef?.current?.view
    if (!scrollElement) return
    const handleScroll = () => {
      if (scrollElement.scrollTop < 110) {
        setStickyHeaderText(null)
      }
    }
    scrollElement.addEventListener('scroll', handleScroll)
    return () => scrollElement.removeEventListener('scroll', handleScroll)
  }, [scrollbarContentRef])

  // There we observe which question is currently the closest one to the top and set its header as a label for a sticky header
  useEffect(() => {
    if (!questionsContainerRef.current) {
      return
    }

    const root =
      scrollbarContentRef?.current instanceof Element
        ? scrollbarContentRef.current
        : null

    if (typeof window === 'undefined' || !window.IntersectionObserver) {
      return
    }

    let observer = null

    const setupIntersectionObserver = () => {
      if (observer) observer.disconnect()

      const rootHeight = root ? root.clientHeight : window.innerHeight
      const ratioBreakpoints = [
        { maxHeight: 600, ratio: 0.7 },
        { maxHeight: 700, ratio: 0.75 },
        { maxHeight: 800, ratio: 0.78 },
        { maxHeight: 900, ratio: 0.80 },
        { maxHeight: 1000, ratio: 0.85 },
        { maxHeight: 1100, ratio: 0.88 },
        { maxHeight: 1200, ratio: 0.90 },
        { maxHeight: Infinity, ratio: 0.92 }
      ]

      const ratio = ratioBreakpoints.find(bp => rootHeight <= bp.maxHeight).ratio
      const bottomMargin = Math.round(rootHeight * ratio)

      observer = new window.IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            const id = entry.target.dataset.questionId
            if (!id) {
              return
            }
            if (entry.isIntersecting) {
              visibleQuestionsRef.current.set(id, {
                top: entry.boundingClientRect.top,
                ratio: entry.intersectionRatio
              })
            } else {
              visibleQuestionsRef.current.delete(id)
            }
          })

          if (visibleQuestionsRef.current.size === 0) {
            return
          }

          const candidates = Array.from(visibleQuestionsRef.current.entries()).map(
            ([id, data]) => ({
              id,
              top: data.top,
              ratio: data.ratio
            })
          )
          const above = candidates.filter(candidate => candidate.top >= 0)
          const sorted = (above.length ? above : candidates).sort(
            (a, b) => Math.abs(a.top) - Math.abs(b.top)
          )
          const next = sorted[0]
          const currentHeader = document.querySelector(`[id="question-header-${next.id}"]`)
          const question = questionMap[next.id]
          if (next && currentHeader) {
            setStickyHeaderText({ text: currentHeader.textContent, tooltip: !question.tooltipAtBottom && question.tooltip })
          }
        },
        {
          root,
          rootMargin: `300px 0px -${bottomMargin}px 0px`,
          threshold: [0, 0.25, 0.5, 0.75, 1]
        }
      )

      const nodes = questionsContainerRef.current?.querySelectorAll(
        '[data-question-id]'
      )
      nodes?.forEach(node => observer.observe(node))
    }

    setupIntersectionObserver()

    const resizeObserver = new window.ResizeObserver(() => {
      visibleQuestionsRef.current.clear()
      setupIntersectionObserver()
    })

    resizeObserver.observe(root ?? document.body)

    return () => {
      observer?.disconnect()
      resizeObserver.disconnect()
      visibleQuestionsRef.current.clear()
    }
  }, [currentTemplate, scrollbarContentRef])

  function isSectionDisabled (template) {
    const notAllDisabled = template.questions.some(question => {
      return !disableFields.includes(question.id) && question.type !== HEADER
    })
    return (
      template.questions.length === 0 ||
      disableFields.includes(template.templateId) ||
      !notAllDisabled
    )
  }

  useEffect(() => {
    let templateToSet = null
    let stepIndex = 0
    data.some((template, index) => {
      const notAllDisabled = template.questions.some(question => {
        return !disableFields.includes(question.id) && question.type !== HEADER
      })
      const unavaliable =
        template.questions.length === 0 ||
        disableFields.includes(template.templateId) ||
        !notAllDisabled

      if (!unavaliable) {
        if (stepIndex === currentStep) {
          templateToSet = template
          return true
        }
        stepIndex++
      }
      return false
    })
    setCurrentTemplate(templateToSet)
    if (scrollbarContentRef && scrollbarContentRef.current) {
      scrollbarContentRef.current.view.scrollTo({ top: 0, behavior: 'smooth' })
      scrollbarContentRef.current.handleWindowResize()
    }

    const first = questionsContainerRef?.current?.querySelector(
      'input:not([disabled]):not([readonly]), textarea:not([disabled]):not([readonly]), select:not([disabled])'
    )
    if (first && typeof first.focus === 'function') {
      first.focus({ preventScroll: true })
    }
  }, [currentStep])

  useEffect(() => {
    if (!pendingScroll) return

    const { id } = pendingScroll

    const raf = window.requestAnimationFrame(() => {
      const domElement = document.getElementById(id)

      if (!domElement) return

      if (scrollbarContentRef?.current) {
        const isCloseToTop = domElement.offsetTop < 300
        const offset = domElement.className.includes('survey-question-card') ? 124 : 100
        scrollbarContentRef.current.view.scrollTo({
          top: isCloseToTop ? 0 : domElement.offsetTop - offset,
          behavior: 'smooth'
        })
      } else {
        domElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }

      setPendingScroll(null)
    })

    return () => window.cancelAnimationFrame(raf)
  }, [currentStep, pendingScroll, scrollbarContentRef])

  useEffect(() => {
    if (
      !saveDisabled &&
      !blockAutoSave &&
      survey &&
      survey.autosave &&
      !isDisabled
    ) {
      const minutes = Number(survey.autosave)
      const handle = setInterval(checkSurveySave, 60000 * minutes)
      return () => {
        clearInterval(handle)
      }
    }
  }, [currentStep, survey, overrideWarningData])

  if (!currentTemplate) {
    return null
  }

  console.log('qqq', opportunity, fundingStreams)

  return (
    <SurveyContextProvider
      disabledFields={disableFields}
    >
      <RedirectWarning
        open={dirty && !savingError}
        handleSave={() => {
          checkSurveySave({ unlock: unlocking })
        }}
      />
      <SaveWillOverrideWarningDialog
        handleSave={() => {
          saveSurvey({ unlock: unlocking })
        }}
        handleClose={() => {
          setOverrideWarningData(null)
          setSubmitting(false)
        }}
        open={Boolean(overrideWarningData)}
        data={overrideWarningData}
      />
      <Box
        className='survey-sticky-header'
        ref={stickyComponentRef}
      >
        {!isSticky &&
          <>
            <Typography className='survey-header-label'>
              {survey.title}
            </Typography>
            {isSAT &&
              <Grid container wrap='nowrap' sx={{ pb: '16px' }}>
                <Typography sx={{ fontSize: '15px', mr: '4px' }}>
                  <Trans>
                    HOW_TO
                  </Trans>
                </Typography>
                <Button
                  sx={{ p: '0px !important', fontSize: '15px !important', fontWeight: 'bold', color: 'text.primary' }}
                  onClick={e => {
                    setShowInfo(!showInfo)
                  }}
                >
                  <Trans>COMPLETE_ORGANIZATIONAL_COMPASS</Trans>
                  <ButtonIcon IconClass={showInfo ? KeyboardArrowUp : KeyboardArrowDown} />
                </Button>
              </Grid>}
            <Collapse in={showInfo}>
              <Typography sx={{ fontSize: '15px', pt: '16px', pb: '16px' }}>
                <Trans>
                  ORGANIZATIONAL_COMPASS_HOW_TO_COMPLETE
                </Trans>
              </Typography>
            </Collapse>
          </>}

        <Grid
          container
          wrap='nowrap'
          sx={{
            pb: '16px',
            flexDirection: { xs: 'column', lg: 'row' },
            alignItems: { xs: isSticky ? 'flex-start' : 'center', lg: isSticky ? 'flex-start' : 'flex-end' },
            justifyContent: isSticky ? 'space-between' : 'center'
          }}
        >
          {activeSections.length > 1 &&
            <SurveyTabStepper
              stickyComponentRef={stickyComponentRef}
              currentStep={currentStep}
              stepperRef={stepperRef}
              data={data}
              disableFields={disableFields}
              setCurrentStep={setCurrentStep}
              sectionToErrors={sectionToErrors}
              isStickyCallback={setIsSticky}
            />}
          {isSticky && stickyHeaderText != null &&
            <>
              <Box
                className='survey-question-header'
                sx={{
                  px: '32px',
                  mt: { xs: '16px', lg: '0px' },
                  mb: '0px !important',
                  alignSelf: 'center',
                  width: { xs: '100%', lg: 'calc(55% + 250px)' },
                  maxWidth: { xs: '900px', lg: 'min(900px, calc(100% - 550px))' }
                }}
              >
                {stickyHeaderText.text}
                {stickyHeaderText.tooltip &&
                  <Box sx={{ mt: '16px', textAlign: 'left' }}>
                    {renderSurveyQuestionToolitp(stickyHeaderText.tooltip)}
                  </Box>}
              </Box>
              <Box sx={{ width: '270px' }} />
            </>}
        </Grid>
        <Divider />
      </Box>

      <Box
        sx={{
          width: { lg: 'calc(55% + 250px)' },
          maxWidth: { xs: '900px', lg: 'min(900px, calc(100% - 550px))' },
          textAlign: 'center'
        }}
        ref={questionsContainerRef}
      >
        <Typography className='required-fields-label' sx={{ marginTop: '8px' }}>
          <Trans>
            REQUIRED_FIELDS_PROMPRT_EDITABLE_FORM
          </Trans>
        </Typography>
        {currentTemplate.skipSection &&
            currentTemplate.skipSection.length > 0 && (
              <FormControlLabel
                checked={Boolean(sectionSkipped)}
                onChange={e => {
                  const toSet = { ...values.skippedSections }
                  const add = e.target.checked
                  const categories = currentTemplate.skipSection
                  const id = currentTemplate.templateId
                  if (!add) {
                    delete toSet[id]
                  } else {
                    toSet[id] = categories
                  }
                  setFieldValue('skippedSections', toSet)
                }}
                control={<Checkbox />}
                labelPlacement='end'
                label={<Trans>Skip section?</Trans>}
              />
        )}
        {currentTemplate.questions.map((item, qIndex) => {
          item.groupQuestionsToDisable = disableFields
          const error = errors[item.id]
          const errorIsArray = Boolean(error && Array.isArray(error))
          const nonApplicableValue = values[item.id + nonApplicableSuffix]
          const disabled =
              isDisabled ||
              sectionSkipped ||
              Boolean(nonApplicableValue && !Array.isArray(nonApplicableValue))
          const nonApplicableDisabled = isDisabled || sectionSkipped
          const showCheckbox =
              item.nonApplicable &&
              !questionTypes[item.type].nonApplicableAsOption

          let toRet = (
            <Box
              sx={{
                ...(item.type === 'HEADER' ? { backgroundColor: 'rgba(154, 199, 101, 0.6)', color: 'primary.main' } : {})
              }}
              className='survey-card'
              key={item.id}
              id={item.id}
              data-question-id={item.id}
            >
              <QuestionTitle
                key={item.id + 'title'}
                nonApplicable={nonApplicableValue}
                question={item}
                errors={!disabled && errors}
                displayIndex={currentIndex + 1}
                version={props.user.language}
              />
              <QuestionWidget
                surveyId={survey.id}
                errorIsArray={errorIsArray}
                entityFiles={entityFiles}
                opportunity={opportunity}
                hideError={sectionSkipped}
                completedSurveys={completedSurveys}
                version={props.user.language}
                questionValue={values[item.id]}
                setFieldValue={setFieldValue}
                disabled={disabled}
                disableFields={disableFields}
                nonApplicable={nonApplicableValue}
                nonApplicableDisabled={nonApplicableDisabled}
                question={item}
                index={item.id}
                key={item.id + 'question'}
                className={classes.question}
              />
              {showCheckbox && (
                <Grid
                  container
                  direction='row'
                  alignItems='center'
                  style={{ marginLeft: 20 }}
                  key={item.id}
                >
                  <CheckboxWithFormik
                    disabled={survey.surveyState === 'Submitted'}
                    style={{ marginLeft: 5 }}
                    name={`${item.id}` + nonApplicableSuffix}
                    row
                    controlLabel={<Trans>Is non applicable</Trans>}
                    onChange={e => {
                      setFieldValue(item.id, questionToInitial(item)[1])
                    }}
                  />
                </Grid>
              )}
            </Box>
          )
          if (disableFields.includes(item.id)) {
            toRet = null
          }
          if (item.type !== 'HEADER' && toRet) {
            currentIndex++
          }
          return toRet
        })}
        {!isDisabled && !noSubmit && currentStep === activeSections.length - 1 && (
          <>
            {errorsPresent &&
              <Grid container sx={{ mt: '24px', mb: '24px' }}>
                <Grid item className='errors-list-strip' sx={{ backgroundColor: 'error.main' }} />
                <Grid item sx={{ backgroundColor: 'flareSecondary.main', paddingLeft: '27px', paddingTop: '17px' }}>
                  <HighlightOff sx={{ width: '30px', height: '30px', fontSize: '30px', color: 'error.main' }} />
                </Grid>
                <Grid item container className='errors-list-container' sx={{ backgroundColor: 'flareSecondary.main' }} gap='12px' xs>
                  <Grid item>
                    <Typography className='errors-list-header' sx={{ color: 'primary.main' }}>
                      <Trans>
                        ERRORS_LIST_HEADER
                      </Trans>
                    </Typography>
                    <Typography className='errors-list-subtitle' sx={{ color: 'primary.main' }}>
                      <Trans>
                        ERRORS_LIST_SUBTITLE
                      </Trans>
                    </Typography>

                    <div className='errors-list-error-container'>
                      {Object.keys(errorsInSections).map((key) => {
                        const errors = errorsInSections[key]
                        const sectionName = sectionToErrors[key]

                        return (
                          <Box key={key}>
                            <Box sx={{ p: '12px' }}>
                              <Typography className='errors-list-section-label'>{sectionName}</Typography>
                            </Box>
                            {errors.map((errorObj, index) => {
                              const isGroupQuestionError = Array.isArray(errorObj.error)
                              const errorQuestionIndex = isGroupQuestionError
                                ? errorObj.error.findIndex(err => err !== undefined)
                                : undefined
                              const q = errorObj.question
                              const groupQuestionErrorId = isGroupQuestionError && errorQuestionIndex > 0
                                ? q.groupQuestions[errorQuestionIndex].id
                                : q.id

                              return (
                                <React.Fragment key={index}>
                                  <Button
                                    sx={{
                                      textTransform: 'none',
                                      justifyContent: 'flex-start',
                                      alignItems: 'center',
                                      flexWrap: 'nowrap',
                                      p: { xs: '8px' }
                                    }}
                                    onClick={() =>
                                      navigateToError({
                                        templateIndex: q.templateIndex - 1,
                                        id: isGroupQuestionError ? groupQuestionErrorId : q.id
                                      })}
                                  >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: '100%'
                                      }}
                                    >
                                      <Typography
                                        className='errors-list-error-text'
                                      >
                                        {q.questionIndex + '.\u00A0' + q.text + '\u00A0:\u00A0'}
                                        {defaultSurveyError}
                                      </Typography>

                                      <ButtonIcon IconClass={NavigateNext} />
                                    </Box>
                                  </Button>
                                  {index !== errors.length - 1 && <Divider />}
                                </React.Fragment>

                              )
                            })}
                          </Box>
                        )
                      })}
                    </div>
                  </Grid>

                </Grid>

              </Grid>}
            {!noEdit &&
              <Button
                fullWidth
                variant='contained'
                color='primary'
                disabled={isSubmitting || errorsPresent}
                onClick={() => {
                  const newValues = { ...formikState.values }
                  newValues.submitButtonType = 'Submitted'
                  newValues.disableFields = disableFields
                  formikState.setValues(newValues)
                  submitSurvey(newValues, {
                    setSubmitting: formikState.setSubmitting,
                    resetForm: formikState.resetForm
                  })
                }}
              >
                <Trans>Submit</Trans>
              </Button>}
          </>
        )}
      </Box>

      {data.length > 1 && (
        <Grid
          container
          direction='row'
          justifyContent='center'
          gap='16px'
          pt='16px'
          pb='16px'
          sx={{
            position: 'sticky',
            borderTop: '1px solid',
            borderColor: '#0000001f',
            bottom: 0,
            zIndex: 10,
            backgroundColor: '#f9f9f6'
          }}
        >
          <Button
            variant='contained'
            color='secondary'
            disabled={isSubmitting || currentStep === 0}
            onClick={() => {
              setCurrentStep(currentStep - 1)
            }}
          >
            <ButtonIcon left IconClass={NavigateBeforeOutlined} />
            <Trans>Back</Trans>
          </Button>
          {!noEdit &&
            <Button
              disabled={saveDisabled || isDisabled || unlocking}
              variant='contained'
              onClick={e => {
                checkSurveySave({ unlock: false })
              }}
            >
              <Trans>
                SAVE
              </Trans>
              <ButtonIcon IconClass={Save} />
            </Button>}
          {Boolean(survey.surveyState === 'Submitted' && (scoreCardExists || isSAT)) &&
            <Grid item>
              <Button
                color='primary'
                variant='contained'
                onClick={e => {
                  history.push(`/surveys/SurveyScore/${survey.id}/${survey.templateId}`)
                }}
              >
                <Grid container justifyContent='center' alignItems='center'>
                  <Trans>Go to score card</Trans>
                  <Icon style={{ marginLeft: 5 }}>bar_chart</Icon>
                </Grid>
              </Button>
            </Grid>}
          {printSurvey && isSAT && (
            <PDFDownloadLink
              document={
                <SurveySubmittedPdf
                  survey={survey}
                  organization={organization}
                  values={values}
                  data={data}
                  disableFields={disableFields}
                  user={user}
                />
              }
              fileName={`${survey.title || 'survey'}, ${moment.utc(survey.modifiedDate).format(dateFormat)}.pdf`}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Button variant='outlined'>
                <Trans>DOWNLOAD</Trans>
                <ButtonIcon IconClass={Download} />
              </Button>
            </PDFDownloadLink>
          )}
          {!noEdit &&
            <Button
              disabled={isSubmitting || unlocking}
              variant='outlined'
              onClick={unlockSurvey}
            >
              <Trans>
                UNLOCK
              </Trans>
              <ButtonIcon IconClass={LockOutlined} />
            </Button>}
          {(errorsPresent && !isDisabled) && (
            <Button
              variant='contained'
              color='primary'
              onClick={() => {
                handleGoToFirstError()
              }}
            >
              <Trans>SURVEY_JUMP_TO_ERROR_BUTTON</Trans>
              <ButtonIcon IconClass={KeyboardTab} />
            </Button>
          )}
          <Button
            variant='outlined'
            color='primary'
            disabled={isSubmitting || currentStep === activeSections.length - 1}
            onClick={() => {
              setCurrentStep(currentStep + 1)
            }}
          >
            <Trans>Next</Trans>
            <ButtonIcon IconClass={NavigateNext} />
          </Button>

        </Grid>
      )}

    </SurveyContextProvider>
  )
}

export const ConfirmationDialog = ({
  open,
  setOpen,
  submitCallback,
  opportunity
}) => {
  const user = useSelector(state => state.user)

  const [checkbox1, setCheckbox1] = useState(false)
  const [checkbox2, setCheckbox2] = useState(false)

  const canSubmit = checkbox1 && checkbox2

  const handleCancel = () => {
    setCheckbox1(false)
    setCheckbox2(false)
    setOpen(false)
  }

  if (!opportunity || !user) {
    return null
  }

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth='xs'
    >
      <DialogTitleWithIconClose
        handleClose={e => {
          setOpen(false)
        }}
        label={<Trans>Confirm submission</Trans>}
      />
      <DialogContent>

        <div style={{ padding: 5 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(checkbox1)}
                onChange={(e) => { setCheckbox1(e.target.checked) }}
              />
                }
            label={`${myI18n._(t`I solemnly declare that the information contained in this report as an honest and complete representation of the project progress for`)} ${opportunity?.info.name}.`}
          />
        </div>

        <div style={{ padding: 5 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(checkbox2)}
                onChange={(e) => { setCheckbox2(e.target.checked) }}
              />
                }
            label={`${myI18n._(t`I affirm that I have the authority to sign this document on behalf of`)} ${opportunity?.info.accountName}.`}
          />
        </div>

        <div style={{ marginLeft: 20, marginBottom: 24 }}>
          <Typography>
            <b>{user.displayName}</b>
          </Typography>
          <Typography>
            {user.userObject && user.userObject.jobTitle}
          </Typography>
        </div>

        <Grid container direction='column' gap='16px'>
          <Button
            disabled={!canSubmit}
            onClick={() => {
              submitCallback()
              handleCancel()
            }}
            variant='contained'
            color='primary'
            fullWidth
          >
            <Trans>Submit</Trans>
          </Button>
          <Button
            onClick={handleCancel}
            variant='outlined'
            color='primary'
            fullWidth
          >
            <Trans>Cancel</Trans>
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

const checkConditionalsBasedOnObject = ({ question, opportunity }) => {
  if (question.conditionalObjectName === 'opportunity') {
    if (question.conditionalObjectSubfield) {
      const toCheck = question.conditionalObjectSubfield
      const oppField = opportunity[question.conditionalObjectField]
      if (typeof oppField === 'object') {
        return oppField.includes(toCheck)
      } else {
        return oppField === toCheck
      }
    } else {
      return Boolean(opportunity[question.conditionalObjectField])
      // const toCheck = question.conditionalObjectField
      // const oppFieldValue = opportunity[question.conditionalObjectField]
      // if (typeof oppFieldValue === 'object') {
      //   return oppFieldValue.includes(toCheck)
      // } else {
      //   return Boolean(oppFieldValue)
      // }
    }
  }
  return false
}

const checkExternalConditions = ({
  question,
  disableFields,
  external,
  values
}) => {
  const toAdd = external
    ? external.disableWholeTemplate
      ? external.template
      : external.disableQuestion
    : false
  if (!external || !toAdd) {
    return
  }
  const fieldValue = values[question.id]
  if (typeof fieldValue === 'object' && fieldValue) {
    fieldValue.forEach((option, index) => {
      if (index === external.option) {
        if (external.isSelected && option) {
          disableFields.push(toAdd)
        } else if (!external.isSelected && !option) {
          disableFields.push(toAdd)
        }
      } else if (external.option === fieldValue[index]) {
        if (external.isSelected && index === external.groupQuestion) {
          if (
            !external.disableWholeTemplate &&
            (external.disableQuestionInGroup ||
              external.disableQuestionInGroup === 0)
          ) {
            disableFields.push(external.disableQuestionInGroup)
          } else {
            disableFields.push(toAdd)
          }
        } else if (
          !external.isSelected &&
          !(external.option === fieldValue[index]) &&
          index === external.groupQuestion
        ) {
          if (!external.disableWholeTemplate) {
            disableFields.push(external.disableQuestionInGroup)
          } else {
            disableFields.push(toAdd)
          }
        }
      } else if (
        !external.isSelected &&
        !(external.option === fieldValue[index]) &&
        index === external.groupQuestion
      ) {
        if (
          !external.disableWholeTemplate &&
          (external.disableQuestionInGroup ||
            external.disableQuestionInGroup === 0)
        ) {
          disableFields.push(external.disableQuestionInGroup)
        } else {
          disableFields.push(toAdd)
        }
      }
    })
  } else if (external.isSelected && fieldValue === external.option) {
    if (
      !external.disableWholeTemplate &&
      (external.disableQuestionInGroup || external.disableQuestionInGroup === 0)
    ) {
      disableFields.push(external.disableQuestionInGroup)
    } else {
      disableFields.push(toAdd)
    }
  } else if (!external.isSelected && fieldValue !== external.option) {
    if (
      !external.disableWholeTemplate &&
      (external.disableQuestionInGroup || external.disableQuestionInGroup === 0)
    ) {
      disableFields.push(external.disableQuestionInGroup)
    } else {
      disableFields.push(toAdd)
    }
  }
}

const checkConditions = ({ condition, values, disableFields, template }) => {
  // check if condition is {}
  const isEmptyCondition = Object.keys(condition).length === 0 && condition.constructor === Object
  if (!condition || isEmptyCondition) {
    return
  }
  // if (!disableFields[template.templateId]) {
  //   disableFields[template.templateId] = []
  // }
  if (condition.isSelected) {
    if (
      typeof values[condition.question] === 'object' &&
      values[condition.question] !== null
    ) {
      if (condition.groupQuestion || condition.groupQuestion === 0) {
        if (
          values[condition.question][condition.groupQuestion] ===
          condition.option
        ) {
          disableFields.push(condition.disableQuestionId)
        }
      } else if (values[condition.question][condition.option]) {
        disableFields.push(condition.disableQuestionId)
      }
    } else {
      if (values[condition.question] === condition.option) {
        disableFields.push(condition.disableQuestionId)
      }
    }
  } else {
    if (
      typeof values[condition.question] === 'object' &&
      values[condition.question] !== null
    ) {
      if (condition.groupQuestion || condition.groupQuestion === 0) {
        if (
          values[condition.question][condition.groupQuestion] !==
          condition.option
        ) {
          disableFields.push(condition.disableQuestionId)
        }
      } else if (!values[condition.question][condition.option]) {
        disableFields.push(condition.disableQuestionId)
      }
    } else if (values[condition.question] !== condition.option) {
      disableFields.push(condition.disableQuestionId)
    }
  }
}

const mapStateToProps = state => ({
  user: state.user,
  organization: state.organization
})

export default withStyles(styles)(
  connect(mapStateToProps, null, null, { forwardRef: true })(SurveyTab)
)
